export type InspectionAircraft = {
  aircraft: string
  inspectionType: 'Annual and 100-hour' | 'Manufacturer phase inspection program' | 'Manufacturer or approved inspection program'
  link?: string
  verified: boolean
}

// Only publish capabilities confirmed against the shop's records.
export const inspectionAircraft: InspectionAircraft[] = [
  { aircraft: 'Cirrus SR20, SR22, SR22T', inspectionType: 'Annual and 100-hour', link: '/maintenance/cirrus', verified: true },
  { aircraft: 'Daher TBM', inspectionType: 'Annual and 100-hour', verified: true },
  { aircraft: 'Cessna Citation CJ series', inspectionType: 'Manufacturer phase inspection program', verified: true },
  { aircraft: 'Cessna single-engine piston [MODELS]', inspectionType: 'Annual and 100-hour', verified: false },
  { aircraft: 'Piper single-engine piston [MODELS]', inspectionType: 'Annual and 100-hour', verified: false },
  { aircraft: 'Beechcraft Bonanza', inspectionType: 'Annual and 100-hour', verified: false },
  { aircraft: 'Beechcraft Baron', inspectionType: 'Annual and 100-hour', verified: false },
  { aircraft: 'Multiengine turboprops [MODELS]', inspectionType: 'Manufacturer or approved inspection program', verified: false },
]

export const verifiedInspectionAircraft = inspectionAircraft.filter((row) => row.verified)
export const annualInspectionAircraft = verifiedInspectionAircraft.filter((row) => row.inspectionType === 'Annual and 100-hour')
export const phaseInspectionAircraft = verifiedInspectionAircraft.filter((row) => row.inspectionType !== 'Annual and 100-hour')

export function inspectionAircraftSentence(rows: readonly InspectionAircraft[]): string {
  return new Intl.ListFormat('en-US', { style: 'long', type: 'conjunction' }).format(rows.map((row) => row.aircraft))
}
